module.exports = __webpack_public_path__ + "static/media/کندانسور-افقی.714101b7.jpg";